import React from 'react';
import styled from 'styled-components';
import * as colors from '../../../../colors';
export default function Label({ children, className, htmlFor, }) {
    return (React.createElement(StyledLabel, { className: className, htmlFor: htmlFor }, children));
}
const StyledLabel = styled.label `
  display: block;
  font-size: 14px;
  color: ${colors.FONT_THIRD};
  font-weight: bold;
  margin-bottom: 4px;
`;
